var _circle, _path, _path2, _circle2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#4A66A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 49.6715 117.39 39.9525 112.794 31.4665C102.246 22.2499 88.442 16.666 73.334 16.666C40.1969 16.666 13.334 43.5289 13.334 76.666C13.334 86.9945 15.9438 96.7135 20.5398 105.2C31.0882 114.416 44.892 120 60 120Z",
    fill: "#687DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78.6654V81.332H36V78.6654L41.3333 73.332V57.332C41.3333 49.0654 46.7467 41.7854 54.6667 39.4387V38.6654C54.6667 37.2509 55.2286 35.8943 56.2288 34.8941C57.229 33.8939 58.5855 33.332 60 33.332C61.4145 33.332 62.771 33.8939 63.7712 34.8941C64.7714 35.8943 65.3333 37.2509 65.3333 38.6654V39.4387C73.2533 41.7854 78.6667 49.0654 78.6667 57.332V73.332L84 78.6654ZM65.3333 83.9987C65.3333 85.4132 64.7714 86.7697 63.7712 87.7699C62.771 88.7701 61.4145 89.332 60 89.332C58.5855 89.332 57.229 88.7701 56.2288 87.7699C55.2286 86.7697 54.6667 85.4132 54.6667 83.9987",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.75,
    cy: 51.75,
    r: 14.75,
    fill: "#EA5B70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.748 57.0004V55.5764L80.356 48.5524H76.18V46.5684H83.252V47.9924L78.644 55.0164H83.3V57.0004H75.748Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47V46.5905L85.2203 44.5706H84.1144V44H85.9873V44.4095L84.7669 46.4294H86V47H84Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.801e1f46064bbf5a34037b6416b5c465.svg";
export { ForwardRef as ReactComponent };